<template lang="pug">
    e-progress-page(v-if="loading")
    div(v-else class="mt-0")
        p-tabs(
            :items="tabs"
            class="m-block-content-effectiveness-assessment__tabs"
        )
        component(:is="tabComponent"
            v-if="assessmentConfiguration"
            :assessment-id="assessmentId"
            :configuration="assessmentConfiguration"
            :assessment="assessment")
</template>

<script>
    import MAccordionEffectivenessAssessment from "@modules/accordions/concrete/m-accordion-effectiveness-assessment";
    import PTabs from "@pages/templates/includes/p-tabs";
    import MBlockContentEffectivenessAssessmentItems
        from "@modules/blocks/content/m-block-content-effectiveness-assessment-items";
    export default {
        name: "m-block-content-effectiveness-assessment",
        components: {MBlockContentEffectivenessAssessmentItems, PTabs, MAccordionEffectivenessAssessment},
        props: {
            assessmentId: {
                type: String,
            },
            assessment: {
                type: Array
            },
            assessmentConfiguration: {
                type: Array
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            tabs() {
                return [
                    {
                        name:'acordion-effectiveness',
                        text: this.$t('modules.blocks.content.m-block-content-effectiveness-assessment.tabs.accordion'),
                        default:true
                    },
                    {
                        name:'needActions',
                        text: this.$t('modules.blocks.content.m-block-content-effectiveness-assessment.tabs.nedAction')
                    }
                ]
            },
            tabComponent() {
                if(this.$route.hash === "#" + this.tabs[1].name) {
                    return MBlockContentEffectivenessAssessmentItems
                } else {
                    return MAccordionEffectivenessAssessment
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .m-block-content-effectiveness-assessment {
        &__tabs {
            /deep/ .tabs__row {
                justify-content: space-around;

                .e-link-item {
                    padding: .5rem 0;
                }
            }
        }
    }
</style>
